import { headerStyles as styles } from "@insite/content-library/Widgets/InvoiceDetails/InvoiceDetailHeader";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

styles.shareEntityButtonStyles = {
    ...styles.shareEntityButtonStyles,
    button: {
        ...styles.shareEntityButtonStyles?.button,
        css: css`
            span {
                color: ${getColor("secondary.main")};
            }
        `,
    },
};

styles.printButton = {
    ...styles.printButton,
    css: css`
        span {
            color: ${getColor("secondary.main")};
        }
    `,
};
